import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import Modal from '../../shared/modals/modal.component';

import { requiredWhenPresent } from '../../shared/propTypes';
import { PeriodPropTypes } from '../../shared/propTypes/period';

import { GlJournalPropTypes } from './propTypes';
import { encodeCountryTaxType } from '../../utils/encodeDecodeCTT';


const DeleteModal = ({
  entityToRemove,
  hideModal,
  removeEntity,
  rowIndex,
  isVisible,
  isRemovingInProgress,
}) => {
  const removeGlJournal = useCallback(() => {
    removeEntity({
      ...entityToRemove,
      countryTaxType: encodeCountryTaxType(
        entityToRemove.countryCode,
        entityToRemove.countryTaxType),
    }, { rowIndex });
  }, [removeEntity, entityToRemove, rowIndex]);

  return (
    <Modal
      className="delete-gl-journal-modal"
      dismissText="Cancel"
      submitText="Yes"
      title="Delete GL Journal"
      closeAction={hideModal}
      dismissAction={hideModal}
      submitAction={removeGlJournal}
      isVisible={isVisible}
      isSubmitting={isRemovingInProgress}

    >
      { entityToRemove
        ? (
          <div>
            Are you sure you want to delete: <br/><br/>
            Period: {entityToRemove.periodName}<br/>
            Country Tax Type: {entityToRemove.countryTaxType}<br/>
            Type: {entityToRemove.type}<br/>
            activity: {entityToRemove.activity}<br/>
            SL Account: {entityToRemove.slAccount}<br/>
            GAAP: {entityToRemove.gaap}<br/>
            G2S: {entityToRemove.g2s}<br/>
            Line: {entityToRemove.line}<br/>
            Direction: {entityToRemove.direction}<br/>
            GL Account Current: {entityToRemove.glAccountCurrent}<br/>
            GL Account Prior: {entityToRemove.glAccountPrior}<br/>
            GL Account 2nd Prior: {entityToRemove.glAccount2ndPrior}<br/>
          </div>
        )
        : null
      }
    </Modal>
  );
};

DeleteModal.propTypes = {
  hideModal: PropTypes.func.isRequired,
  removeEntity: PropTypes.func.isRequired,
  period: PeriodPropTypes.isRequired,
  entityToRemove: requiredWhenPresent(['isVisible'], GlJournalPropTypes),
  rowIndex: requiredWhenPresent(['isVisible'], PropTypes.number),
  isVisible: PropTypes.bool,
  isRemovingInProgress: PropTypes.bool.isRequired,
};

export default DeleteModal;
